/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type TaxUsageType = (typeof TaxUsageType)[keyof typeof TaxUsageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxUsageType = {
  Including: 0,
  Excluding: 1,
  NoTax: 2,
} as const;
